<template>
  <div class="investment-estimate-software">
    <h2>开发中</h2>
    <p>敬请期待</p>
  </div>
</template>

<script>
export default {
  name: 'InvestmentEstimateSoftware',
  data() {
    return {
      // 页面数据
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
  }
}
</script>

<style scoped>
.investment-estimate-software {
  padding: 20px;
}
</style>
